<script setup lang="ts">
import { ref, onMounted } from "vue";
import { fetchCustomConfig } from "~/server/adminApiClient";

const props = defineProps<{
  navigationId: string;
}>();

const { apiClient } = useShopwareContext();

const { buildDynamicBreadcrumbs, pushBreadcrumb } = useBreadcrumbs();

const blog = ref(null);
const loading = ref(true);
const error = ref("");
async function fetchBlogDetails() {
  loading.value = true;
  error.value = "";

  try {
    const response = await apiClient.invoke(
      "getBlogs post /blogpost/{postId}",
      {
        pathParams: { postId: props.navigationId },
      }
    );
    blog.value = response?.data || {};
  } catch (err) {
    error.value = err.message || "Failed to load blog details.";
    console.error("Error loading blog:", err);
  } finally {
    loading.value = false;
  }
}

onMounted(() => {
  fetchBlogDetails();
});

onMounted(async () => {
  const config = await fetchCustomConfig(); // ✅ Wait for the response
  if (config && config.data) {
    const navigationCategory =
      config.data["NetzpBlog6.config.navigationcategory"];

    const breadCrumbResponse = await apiClient
      .invoke("readBreadcrumb get /breadcrumb/{id}", {
        pathParams: {
          id: navigationCategory,
        },
      })
      .catch(() => {
        console.error("Error while fetching breadcrumbs");
      });
    if (breadCrumbResponse) {
      buildDynamicBreadcrumbs(breadCrumbResponse.data);
      pushBreadcrumb({
        name: blog.value.title ?? "",
        path: "",
      });
    }
  }
});
</script>

<template>
  <section>
    <LayoutBreadcrumbs />
    <LoadingOverlay :show="loading" />
    <CommonBlogDetail v-if="blog" :blog-data="blog" />
  </section>
</template>
